import { ThunkDispatch } from "@reduxjs/toolkit";
import { Action } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { selector as dashboardApi, getDashboardDetails } from './dashboardSlice';
import { useSpinner } from '../../customHooks';
import { Status, DefaultTopLevelGroup, MIMO_GROUP_ID } from "../../common/constants";
import { useEffect, useState } from "react";
import { IDashboardDetails } from "../../common/types/devicesTypes";
import { useNavigate, NavigateFunction } from "react-router-dom";
import { fetchQuickAlertsData, selector as listQuickAlertsApi } from '../alerts/quickAlerts/listQuickAlerts/listQuickAlertsSlice';
import { IBaseLicenseDetails, ILicensingDetail } from "../../common/types/mobileLicensingTypes";

const useDashboard = () => {
    const isMimoAccount: boolean = DefaultTopLevelGroup.ID == MIMO_GROUP_ID;
    const dispatch: ThunkDispatch<IDashboardDetails, undefined, Action> = useDispatch();
    const INITIAL_VALUE: number = 0;
    const dashboardData: IDashboardDetails = useSelector(dashboardApi);
    const quickalerts = useSelector(listQuickAlertsApi);
    const quickAlertsStatus=quickalerts.status;
    useSpinner(dashboardData.status);
    const [quickAlertsData, setQuickAlertsData] = useState<any[]>([]);
    const [quickAlertsNumber, setQuickAlertsNumber] = useState<number>(INITIAL_VALUE);
    const [activeAlertsNumber, setActiveAlertsNumber] = useState<number>(INITIAL_VALUE);
    const [approvalAlertsNumber, setApprovalAlertsNumber] = useState<number>(INITIAL_VALUE);
    const [offlineDevicesNumber, setOfflineDevicesNumber] = useState<number>(INITIAL_VALUE);
    const [offlineDevicesPercentage, setOfflineDevicesPercentage] = useState<number>(INITIAL_VALUE);
    const [licenseDetails, setLicenseDetails] = useState<IBaseLicenseDetails>();
    const navigate: NavigateFunction = useNavigate();


    const handleNavigation = (route: string) => {
        navigate(route);
    }

    useEffect(() => {
        if (dashboardData && dashboardData.data) {
            setActiveAlertsNumber(dashboardData.data.severeAlerts);
            setApprovalAlertsNumber(dashboardData.data.approvalAlerts);
            setOfflineDevicesNumber(dashboardData.data.offlineDevices);
            setOfflineDevicesPercentage(dashboardData.data.offlineDevicePercentage);
            if (dashboardData?.data?.licenseDetails?.length > 0) {
                const mobileLicense = dashboardData.data.licenseDetails.find(
                  (item: ILicensingDetail) => item.type === "mobile"
                );
            
                if (mobileLicense && mobileLicense.mobileLicenseDetails) {
                  const license = mobileLicense.mobileLicenseDetails as IBaseLicenseDetails;
                  setLicenseDetails(license);
                }
              }
        }
    }, [dashboardData])

    useEffect(() => {
        dispatch(getDashboardDetails());
    }, [])

        if (quickalerts.status == Status.IDLE) {
            dispatch(fetchQuickAlertsData({page:1,limit:10}))
        }
        useEffect(() => {
            if (quickalerts.quickalerts && quickalerts.quickalerts.values !== quickAlertsData) {
                setQuickAlertsNumber(quickalerts?.quickalerts?.total);
                setQuickAlertsData(quickalerts.quickalerts.values);
            }
        }, [quickalerts.quickalerts]) 

    return {
        activeAlertsNumber,
        approvalAlertsNumber,
        offlineDevicesNumber,
        offlineDevicesPercentage,
        handleNavigation,
        quickAlertsData,
        quickAlertsNumber,
        isMimoAccount,
        quickAlertsStatus,
        licenseDetails,
    }
}

export default useDashboard;